import { useSyncExternalStore } from 'react'

// Which way the screen is held, from the same media query CSS uses, so the
// two agree. Cooking mode on the phone wants landscape (CookingMode).
export type Orientation = 'portrait' | 'landscape'

const QUERY = '(orientation: portrait)'

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {}
  const mq = window.matchMedia(QUERY)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

function snapshot(): Orientation {
  if (typeof window === 'undefined' || !window.matchMedia) return 'portrait'
  return window.matchMedia(QUERY).matches ? 'portrait' : 'landscape'
}

export function useOrientation(): Orientation {
  return useSyncExternalStore(subscribe, snapshot, () => 'portrait')
}
